export default {
      id: "ic_authors_down-usage",
      viewBox: "0 0 9 15",
      url: "/" + "images/icons.3.109.2.svg#ic_authors_down-usage",
      toString: function () {
        return this.url;
      }
    }